import { InputError } from '@foodsby/nutrient'
import { Box, MenuItem, TextField } from '@material-ui/core'
import { get } from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'

import { pushSnowplow, toOrderProcessSchema } from '../../util/snowplow'
import CreditCardDetail from './CreditCardDetail'

const BillingInfo = ({
  clearError,
  creditCards,
  creditCardsError,
  errors,
  handleBlur,
  handleChange,
  setFieldTouched,
  setFieldValue,
  touched,
  values,
}) => {
  const options = [
    ...creditCards.map(card => ({
      label: `XXXX-XXXX-XXXX-${card.lastFour}`,
      value: card.ccProfileId,
    })),
    { label: 'Add New Card', value: -1 },
  ]
  const [didSetDefaultCard, setDidSetDefaultCard] = useState(false)

  useEffect(() => {
    if (!didSetDefaultCard && creditCards && creditCards.length === 1) {
      setFieldValue('SelectedCard', creditCards[0].ccProfileId)
      setDidSetDefaultCard(true)
    }
  }, [creditCards, didSetDefaultCard, handleBlur, setFieldTouched, setFieldValue, values])

  useEffect(() => {
    if (touched.SelectedCard && errors.SelectedCard) {
      pushSnowplow(toOrderProcessSchema('daily', 'checkout', errors.SelectedCard))
    }
  }, [errors.SelectedCard, touched.SelectedCard])

  const getError = useCallback(name => get(touched, name) && get(errors, name), [errors, touched])

  return (
    <>
      {creditCards && creditCards.length > 0 ? (
        <>
          <Box mb={3}>
            <TextField
              color="secondary"
              error={!!getError('SelectedCard')}
              fullWidth
              helperText={getError('SelectedCard')}
              label="Select a Card"
              name="SelectedCard"
              onBlur={handleBlur}
              onChange={evt => {
                pushSnowplow(
                  toOrderProcessSchema(
                    'daily',
                    'checkout_credit_card_select',
                    options.filter(card => card.value === evt.target.value)[0].label,
                  ),
                )
                setFieldValue('SelectedCard', evt.target.value)
                clearError()
              }}
              select
              size="small"
              value={
                options.filter(card => card.value === values.SelectedCard)[0]?.value ||
                (creditCards.length > 1 ? '' : -1)
              }
              variant="outlined"
            >
              {options.map(opt => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          {values.SelectedCard === -1 && (
            <CreditCardDetail
              creditCards={creditCards}
              errors={errors}
              handleBlur={handleBlur}
              handleChange={handleChange}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              touched={touched}
              values={values}
            />
          )}
        </>
      ) : (
        <CreditCardDetail
          creditCards={creditCards}
          errors={errors}
          handleBlur={handleBlur}
          handleChange={handleChange}
          setFieldTouched={setFieldTouched}
          setFieldValue={setFieldValue}
          touched={touched}
          values={values}
        />
      )}
      <InputError>{creditCardsError}</InputError>
    </>
  )
}

export default BillingInfo
